import type { BillProtectionFeatureConfig } from '../../../types/insurances/BillProtectionFeatureConfig';

export const billProtection: BillProtectionFeatureConfig = {
    overview: {
        details: {
            fallbackAssistancePhonesKey: 'RO_BILL_PROTECTION',
            fallbackAssistanceEmailsKey: 'RO_BILL_PROTECTION',
        },
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
